import React from 'react';
import { Alert } from '../../modules/ui-kit-react/lib';
import withAuth from 'components/Auth';
import { Link } from 'react-router-dom';
import { ShieldAuthContextData } from '../../types';
import getUserRole from '../../utils/getUserRole';
import style from './style.module.css';
import { useTenant } from "../../context/TenantContext";

interface AccessNoticeProps {
  auth: ShieldAuthContextData;
}

const AccessNotice: React.FC<AccessNoticeProps> = ({ auth }) => {
  const { currentTenant } = useTenant();
  return auth.profile.roles && getUserRole(auth.profile.roles) === 'read-only' ? (
    <Alert
      // @ts-ignore
      theme={{
        alert: style.alert
      }}
      type="warning"
      message={
        <span>
          You have read-only permission for this tenant. Find out how to gain
          additional access <Link to={`/${currentTenant}/access`}>here.</Link>
        </span>
      }
    />
  ) : null;
}
export default withAuth(AccessNotice);
